var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRoulette(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1912_150)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H512V512H0V0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1912_150)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.003 46.0024C140.021 46.0024 46 140.015 46 256.005C46 371.977 140.021 465.997 256.003 465.997C371.979 465.997 466 371.977 466 256.005C466 140.014 371.979 46.0024 256.003 46.0024Z",
    fill: "#703D2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.002 85.3623C161.759 85.3623 85.3599 161.754 85.3599 256.003C85.3599 350.239 161.759 426.637 256.002 426.637C350.24 426.637 426.639 350.24 426.639 256.003C426.64 161.754 350.24 85.3623 256.002 85.3623Z",
    fill: "#A56C42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.002 118.374C179.992 118.374 118.373 179.986 118.373 256.002C118.373 332.008 179.992 393.626 256.002 393.626C332.009 393.626 393.628 332.007 393.628 256.002C393.627 179.987 332.009 118.374 256.002 118.374Z",
    fill: "#C6B8AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.002 124.827C183.555 124.827 124.826 183.551 124.826 256.002C124.826 328.443 183.555 387.172 256.002 387.172C328.445 387.172 387.174 328.443 387.174 256.002C387.173 183.552 328.445 124.827 256.002 124.827Z",
    fill: "#BA7C49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.583 180.785C144.143 187.103 140.33 193.734 137.137 200.572L256.001 256L148.583 180.785Z",
    fill: "#CE2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.136 200.572C133.891 207.542 131.289 214.73 129.334 222.059L256.001 256L137.136 200.572Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.286 163.284C157.788 168.779 152.899 174.639 148.583 180.785L256.001 256L163.286 163.284Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.334 222.059C127.359 229.454 126.046 236.986 125.391 244.571L256.001 256L129.334 222.059Z",
    fill: "#CE2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.785 148.583C174.636 152.899 168.778 157.795 163.286 163.284L256.001 256L180.785 148.583Z",
    fill: "#CE2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.583 331.215L255.991 256.007L137.144 311.427C140.33 318.272 144.148 324.891 148.583 331.215ZM255.998 256.001L255.991 256.006L256.001 256.001H255.998Z",
    fill: "#CE2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.391 244.571C124.724 252.173 124.732 259.823 125.388 267.427L256.001 256L125.391 244.571Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.337 289.939C131.293 297.268 133.891 304.466 137.145 311.427L256.002 256.001L129.337 289.939Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.388 267.427C126.046 275.009 127.361 282.544 129.337 289.939L256.001 256.002V256L125.388 267.427Z",
    fill: "#CE2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.713 163.29L256.001 256L363.417 180.785C359.104 174.638 354.208 168.78 348.713 163.29Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.571 137.137C193.729 140.331 187.108 144.143 180.786 148.583L256.001 256L200.571 137.137Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.427 125.39L256.001 256L289.94 129.334C282.547 127.358 275.009 126.047 267.427 125.39Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.426 137.141L256.001 256L331.216 148.582C324.896 144.146 318.272 140.325 311.426 137.141Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.216 148.582L256.001 256L348.713 163.29C343.224 157.797 337.358 152.899 331.216 148.582Z",
    fill: "#CE2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.94 129.334L256.001 256L311.426 137.14C304.463 133.891 297.266 131.296 289.94 129.334Z",
    fill: "#CE2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.583 331.216C152.899 337.362 157.795 343.221 163.29 348.711L255.998 256.002L148.583 331.216Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.573 125.389L256.001 256L267.427 125.389C259.824 124.726 252.175 124.726 244.573 125.389Z",
    fill: "#357157"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.573 125.39C236.995 126.047 229.455 127.358 222.06 129.335L256.001 256L244.573 125.39Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.06 129.334C214.728 131.29 207.54 133.891 200.571 137.136L256.001 256L222.06 129.334Z",
    fill: "#CE2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.001 256L382.667 289.938C384.642 282.544 385.951 275.007 386.608 267.427L256.001 256Z",
    fill: "#CE2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.001 256L363.419 331.215C367.855 324.892 371.671 318.272 374.864 311.423L256.001 256Z",
    fill: "#CE2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.616 244.575L256.001 256L386.609 267.427C387.27 259.821 387.272 252.173 386.616 244.575Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.668 222.064L256.001 256L386.616 244.575C385.952 236.995 384.643 229.454 382.668 222.064Z",
    fill: "#CE2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.417 180.785L256.001 256L374.862 200.574C371.671 193.727 367.856 187.108 363.417 180.785Z",
    fill: "#CE2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.862 200.574L256.001 256L382.668 222.064C380.711 214.738 378.108 207.539 374.862 200.574Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.001 256L348.714 348.714C354.208 343.224 359.104 337.363 363.419 331.215L256.001 256Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.997 256.001L163.289 348.711C168.779 354.207 174.642 359.102 180.785 363.423L256.001 256.001H255.997Z",
    fill: "#CE2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.001 256V256.002L244.576 386.612C252.178 387.273 259.828 387.273 267.43 386.609L256.001 256Z",
    fill: "#CE2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.574 374.861C207.54 378.113 214.734 380.711 222.06 382.666L256.001 256.003V256L200.574 374.861Z",
    fill: "#CE2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.06 382.666C229.456 384.638 236.995 385.958 244.576 386.613L256.001 256.002L222.06 382.666Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.574 374.861L255.998 256.006L180.786 363.423C187.11 367.855 193.729 371.671 200.574 374.861ZM255.998 256.006L256.001 256.002V256L255.998 256.006Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.001 256L267.43 386.609C275.014 385.955 282.545 384.637 289.94 382.665L256.001 256Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.001 256L311.426 374.861C318.272 371.671 324.892 367.855 331.215 363.42L256.001 256Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.001 256L331.215 363.42C337.363 359.105 343.224 354.207 348.714 348.714L256.001 256Z",
    fill: "#CE2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.001 256L289.94 382.666C297.272 380.708 304.46 378.113 311.426 374.861L256.001 256Z",
    fill: "#CE2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.001 256L374.865 311.423C378.108 304.46 380.711 297.269 382.668 289.938L256.001 256Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.001 145.13C194.768 145.13 145.128 194.765 145.128 256.002C145.128 317.23 194.767 366.869 256.001 366.869C317.231 366.869 366.871 317.23 366.871 256.002C366.871 194.766 317.232 145.13 256.001 145.13Z",
    fill: "#BFAFA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.001 150.953C197.983 150.953 150.951 197.982 150.951 256.003C150.951 314.016 197.984 361.048 256.001 361.048C314.016 361.048 361.048 314.015 361.048 256.003C361.049 197.981 314.016 150.953 256.001 150.953Z",
    fill: "#C6854A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.002 194.382C164.364 199.557 161.241 204.989 158.625 210.592L256.001 256L168.002 194.382Z",
    fill: "#E03636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.625 210.593C155.966 216.302 153.834 222.191 152.233 228.196L256.001 256L158.625 210.593Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.047 180.045C175.543 184.546 171.538 189.347 168.002 194.382L256.001 256L180.047 180.045Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.233 228.196C150.615 234.254 149.539 240.424 149.003 246.638L256.001 256L152.233 228.196Z",
    fill: "#E03636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.383 168.002C189.345 171.537 184.546 175.549 180.046 180.045L256.001 256L194.383 168.002Z",
    fill: "#E03636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.001 317.618L255.991 256.006L158.631 301.407C161.241 307.014 164.369 312.436 168.001 317.618ZM255.998 256.001L255.992 256.006L256.001 256.001H255.998Z",
    fill: "#E03636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.004 246.638C148.457 252.865 148.463 259.132 149 265.362L256.001 256L149.004 246.638Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.235 283.804C153.837 289.808 155.966 295.704 158.631 301.408L256 256.002L152.235 283.804Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149 265.361C149.54 271.572 150.617 277.745 152.235 283.804L256.001 256.003V256L149 265.361Z",
    fill: "#E03636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.952 180.05L256.001 256L343.998 194.382C340.465 189.347 336.453 184.547 331.952 180.05Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.591 158.625C204.986 161.242 199.562 164.365 194.383 168.003L256.001 256L210.591 158.625Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.361 149.001L256.001 256L283.804 152.233C277.747 150.614 271.572 149.54 265.361 149.001Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.406 158.628L256.001 256L317.619 168.001C312.441 164.368 307.014 161.237 301.406 158.628Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.619 168.001L256.001 256L331.952 180.05C327.455 175.55 322.65 171.539 317.619 168.001Z",
    fill: "#E03636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.804 152.233L256.001 256L301.406 158.628C295.702 155.966 289.805 153.84 283.804 152.233Z",
    fill: "#E03636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.002 317.618C171.538 322.653 175.549 327.453 180.05 331.951L255.998 256.002L168.002 317.618Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.638 149.001L256.001 256L265.361 149.001C259.132 148.459 252.866 148.459 246.638 149.001Z",
    fill: "#398764"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.639 149.001C240.43 149.54 234.253 150.614 228.196 152.233L256.001 256L246.639 149.001Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.197 152.233C222.19 153.836 216.301 155.966 210.592 158.625L256.001 256L228.197 152.233Z",
    fill: "#E03636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.001 256L359.768 283.803C361.385 277.745 362.458 271.571 362.996 265.361L256.001 256Z",
    fill: "#E03636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.001 256L344 317.618C347.634 312.437 350.759 307.015 353.377 301.404L256.001 256Z",
    fill: "#E03636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.003 246.64L256.001 256L362.997 265.361C363.539 259.13 363.54 252.864 363.003 246.64Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.768 228.199L256.001 256L363.003 246.64C362.459 240.431 361.387 234.254 359.768 228.199Z",
    fill: "#E03636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.999 194.382L256.001 256L353.374 210.594C350.76 204.985 347.634 199.562 343.999 194.382Z",
    fill: "#E03636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.374 210.594L256.001 256L359.768 228.199C358.166 222.197 356.032 216.301 353.374 210.594Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.001 256L331.954 331.953C336.454 327.455 340.465 322.654 343.999 317.617L256.001 256Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.998 256.001L180.051 331.95C184.548 336.452 189.351 340.463 194.384 344.002L256.002 256.001H255.998Z",
    fill: "#E03636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.001 256V256.002L246.642 363C252.87 363.542 259.136 363.542 265.364 362.997L256.001 256Z",
    fill: "#E03636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.594 353.373C216.301 356.037 222.194 358.165 228.197 359.767L256.001 256.002V256L210.594 353.373Z",
    fill: "#E03636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.197 359.767C234.256 361.383 240.431 362.464 246.642 363L256.001 256.001L228.197 359.767Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.998 256.005L256.001 256.002V256L255.998 256.005ZM210.594 353.373L255.998 256.005L194.383 344.003C199.564 347.634 204.986 350.759 210.594 353.373Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.001 256L265.364 362.997C271.576 362.462 277.746 361.382 283.804 359.767L256.001 256Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.001 256L301.406 353.373C307.014 350.76 312.437 347.634 317.617 344L256.001 256Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.001 256L317.617 344C322.654 340.466 327.455 336.453 331.954 331.953L256.001 256Z",
    fill: "#E03636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.001 256L283.804 359.767C289.811 358.163 295.699 356.037 301.406 353.373L256.001 256Z",
    fill: "#E03636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.001 256L353.377 301.403C356.032 295.699 358.166 289.808 359.769 283.803L256.001 256Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 167.938C260.207 167.938 263.618 164.527 263.618 160.32C263.618 156.112 260.207 152.701 256 152.701C251.792 152.701 248.381 156.112 248.381 160.32C248.381 164.527 251.792 167.938 256 167.938Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.766 153.502C252 153.502 248.945 156.555 248.945 160.323C248.945 164.091 251.999 167.143 255.766 167.143C259.533 167.143 259.533 153.502 255.766 153.502Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.001 172.653C209.969 172.653 172.652 209.967 172.652 256.002C172.652 302.031 209.969 339.348 256.001 339.348C302.031 339.348 339.348 302.031 339.348 256.002C339.348 209.966 302.031 172.653 256.001 172.653Z",
    fill: "#CEC0B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.001 176.145C211.897 176.145 176.144 211.895 176.144 256.002C176.144 300.102 211.897 335.855 256.001 335.855C300.103 335.855 335.856 300.102 335.856 256.002C335.856 211.895 300.103 176.145 256.001 176.145Z",
    fill: "#D89450"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.307 202.356C278.326 173.374 231.338 173.372 202.354 202.356C173.374 231.336 173.374 278.326 202.356 307.308C216.815 321.766 250.184 302.889 276.395 276.74C302.722 250.478 321.83 216.879 307.307 202.356Z",
    fill: "#E09F65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.27 175.845H254.73V336.164H257.27V175.845Z",
    fill: "#685B51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.164 254.73H175.844V257.27H336.164V254.73Z",
    fill: "#685B51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.782 198.418L198.42 311.78L200.216 313.576L313.578 200.214L311.782 198.418Z",
    fill: "#685B51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.216 198.424L198.42 200.22L311.782 313.582L313.578 311.786L200.216 198.424Z",
    fill: "#685B51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 281.679C270.182 281.679 281.679 270.182 281.679 256C281.679 241.817 270.182 230.32 256 230.32C241.817 230.32 230.32 241.817 230.32 256C230.32 270.182 241.817 281.679 256 281.679Z",
    fill: "#685B51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 267.183C262.176 267.183 267.183 262.176 267.183 256C267.183 249.824 262.176 244.817 256 244.817C249.824 244.817 244.817 249.824 244.817 256C244.817 262.176 249.824 267.183 256 267.183Z",
    fill: "#4C4642"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.933 87.5234C254.452 87.5234 251.277 93.7766 251.277 101.491C251.277 109.205 254.028 115.458 255.933 115.458C257.838 115.458 260.589 109.205 260.589 101.491C260.589 93.7766 257.415 87.5234 255.933 87.5234Z",
    fill: "#C1BDBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.933 87.5234C254.452 87.5234 251.277 93.7766 251.277 101.491C251.277 109.205 254.028 115.458 255.933 115.458C257.838 115.458 257.415 87.5234 255.933 87.5234Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.933 396.498C254.452 396.498 251.277 402.751 251.277 410.465C251.277 418.179 254.028 424.432 255.933 424.432C257.838 424.432 260.589 418.179 260.589 410.465C260.589 402.751 257.415 396.498 255.933 396.498Z",
    fill: "#C1BDBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.933 396.498C254.452 396.498 251.277 402.751 251.277 410.465C251.277 418.179 254.028 424.432 255.933 424.432C257.838 424.432 257.415 396.498 255.933 396.498Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.42 251.322C402.706 251.322 396.453 254.073 396.453 255.978C396.453 257.883 402.706 260.634 410.42 260.634C418.134 260.634 424.388 257.459 424.388 255.978C424.388 254.497 418.134 251.322 410.42 251.322Z",
    fill: "#C1BDBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.42 251.322C402.706 251.322 396.453 254.073 396.453 255.978C396.453 257.883 424.388 257.459 424.388 255.978C424.388 254.497 418.134 251.322 410.42 251.322Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.446 251.322C93.7319 251.322 87.4788 254.073 87.4788 255.978C87.4788 257.883 93.7319 260.634 101.446 260.634C109.16 260.634 115.413 257.459 115.413 255.978C115.413 254.497 109.16 251.322 101.446 251.322Z",
    fill: "#C1BDBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.446 251.322C93.7319 251.322 87.4788 254.073 87.4788 255.978C87.4788 257.883 115.413 257.459 115.413 255.978C115.413 254.497 109.16 251.322 101.446 251.322Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.049 136.863C374.001 135.816 367.335 137.992 361.88 143.447C356.425 148.902 353.949 155.268 355.296 156.615C356.643 157.962 363.009 155.486 368.464 150.031C373.919 144.577 376.096 137.91 375.049 136.863Z",
    fill: "#C1BDBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.049 136.863C374.001 135.816 367.335 137.992 361.88 143.447C356.425 148.902 353.949 155.268 355.296 156.615C356.643 157.962 376.096 137.91 375.049 136.863Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.571 355.341C155.524 354.293 148.858 356.47 143.403 361.925C137.948 367.38 135.472 373.746 136.819 375.094C138.166 376.441 144.533 373.965 149.987 368.51C155.441 363.054 157.618 356.388 156.571 355.341Z",
    fill: "#C1BDBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.571 355.341C155.524 354.293 148.858 356.47 143.403 361.925C137.948 367.38 135.472 373.746 136.819 375.094C138.165 376.44 157.618 356.388 156.571 355.341Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.464 361.925C363.009 356.47 356.643 353.994 355.296 355.341C353.949 356.687 356.425 363.054 361.88 368.509C367.335 373.964 374.001 376.141 375.049 375.093C376.096 374.046 373.919 367.38 368.464 361.925Z",
    fill: "#C1BDBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.464 361.925C363.009 356.47 356.643 353.994 355.296 355.341C353.949 356.687 374.001 376.141 375.048 375.093C376.096 374.046 373.919 367.38 368.464 361.925Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.986 143.447C144.532 137.992 138.165 135.516 136.818 136.863C135.471 138.21 137.947 144.577 143.402 150.031C148.857 155.486 155.523 157.663 156.57 156.615C157.618 155.567 155.441 148.902 149.986 143.447Z",
    fill: "#C1BDBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.986 143.447C144.532 137.992 138.165 135.516 136.818 136.863C135.471 138.21 155.523 157.663 156.57 156.615C157.618 155.567 155.441 148.902 149.986 143.447Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.084 109.13C309.97 106.15 303.139 106.27 302.403 108.027C301.667 109.783 306.371 114.738 313.485 117.718C320.6 120.7 327.594 120.188 328.167 118.823C328.74 117.456 324.199 112.112 317.084 109.13Z",
    fill: "#C1BDBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.085 109.13C309.97 106.15 303.139 106.27 302.403 108.027C301.667 109.783 327.595 120.189 328.167 118.823C328.74 117.456 324.199 112.112 317.085 109.13Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.384 392.406C191.269 389.424 184.438 389.545 183.703 391.302C182.966 393.058 187.671 398.012 194.785 400.994C201.9 403.975 208.894 403.464 209.466 402.098C210.039 400.732 205.498 395.387 198.384 392.406Z",
    fill: "#C1BDBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.384 392.406C191.269 389.424 184.438 389.545 183.703 391.302C182.966 393.058 208.894 403.464 209.467 402.097C210.039 400.732 205.498 395.387 198.384 392.406Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.971 301.531C401.214 300.796 396.261 305.5 393.279 312.614C390.298 319.728 390.809 326.722 392.175 327.295C393.542 327.868 398.887 323.327 401.868 316.213C404.848 309.098 404.727 302.267 402.971 301.531Z",
    fill: "#C1BDBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.971 301.531C401.214 300.795 390.809 326.723 392.176 327.295C393.542 327.867 398.887 323.327 401.868 316.213C404.848 309.098 404.727 302.267 402.971 301.531Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.696 182.83C117.939 182.093 112.985 186.798 110.003 193.912C107.023 201.027 107.534 208.021 108.899 208.593C110.266 209.166 115.61 204.625 118.591 197.511C121.572 190.396 121.452 183.565 119.696 182.83Z",
    fill: "#C1BDBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.696 182.83C117.939 182.093 107.533 208.021 108.9 208.594C110.266 209.167 115.61 204.626 118.591 197.512C121.573 190.396 121.452 183.565 119.696 182.83Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.331 195.033C399.408 187.895 394.492 183.15 392.73 183.871C390.968 184.593 390.791 191.422 393.714 198.561C396.637 205.701 401.943 210.285 403.314 209.724C404.685 209.161 405.254 202.173 402.331 195.033Z",
    fill: "#C1BDBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.331 195.033C399.408 187.895 394.492 183.15 392.73 183.871C390.967 184.593 401.943 210.285 403.314 209.723C404.685 209.161 405.254 202.173 402.331 195.033Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.09 311.404C115.167 304.265 110.252 299.52 108.49 300.242C106.727 300.964 106.551 307.793 109.474 314.933C112.396 322.071 117.703 326.656 119.075 326.095C120.445 325.533 121.014 318.544 118.09 311.404Z",
    fill: "#C1BDBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.09 311.404C115.167 304.265 110.252 299.52 108.49 300.242C106.727 300.964 117.703 326.656 119.074 326.095C120.445 325.533 121.014 318.544 118.09 311.404Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.014 391.812C326.292 390.049 319.463 389.872 312.324 392.795C305.184 395.718 300.601 401.026 301.162 402.396C301.723 403.768 308.713 404.336 315.852 401.413C322.991 398.49 327.736 393.574 327.014 391.812Z",
    fill: "#C1BDBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.014 391.812C326.292 390.049 300.601 401.025 301.162 402.395C301.723 403.767 308.713 404.335 315.852 401.413C322.991 398.49 327.736 393.574 327.014 391.812Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.643 107.572C209.921 105.808 203.092 105.631 195.952 108.554C188.814 111.477 184.229 116.784 184.79 118.155C185.352 119.526 192.341 120.094 199.48 117.172C206.62 114.249 211.365 109.334 210.643 107.572Z",
    fill: "#C1BDBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.643 107.572C209.921 105.808 184.229 116.784 184.79 118.155C185.352 119.526 192.341 120.094 199.48 117.172C206.62 114.249 211.365 109.334 210.643 107.572Z",
    fill: "#D8D8D8"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1912_150"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1912_150"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 420,
    height: 420,
    fill: "white",
    transform: "translate(46 46)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoulette);
export default __webpack_public_path__ + "static/media/roulette.e467e3ff8c5ac340af730e27c52747bc.svg";
export { ForwardRef as ReactComponent };